import {Application} from "@hotwired/stimulus"
import {definitionsFromContext} from "@hotwired/stimulus-webpack-helpers"

window.Stimulus = Application.start()

// controllers locais
const context = require.context('./controllers', true, /\.js$/)
Stimulus.load(definitionsFromContext(context))

// controllers de views/templates
const viewsContext = require.context(
    './../../view/templates',
    true,
    /-controller\.js$/,
)

Stimulus.load(definitionsFromContext(viewsContext))

const vendorContext = require.context(
    './../../../vendor/eproc/ui-twig-components/assets/controllers',
    true,
    /-controller\.js$/,
)

Stimulus.load(definitionsFromContext(vendorContext).map(definition => ({
    ...definition,
})))
